export const checkFilled = (trait_group) => {
    let flag = false
    for(let i in trait_group.traits){
        if((typeof trait_group.traits[i]?.currentValue === 'string' && trait_group.traits[i]?.currentValue!=='') || (typeof trait_group.traits[i]?.currentValue === 'boolean')){
            flag= true
            return flag
        }
        else if(typeof trait_group.traits[i]?.currentValue === 'object'){
            flag = check_object_fill(trait_group.traits[i]?.currentValue)
            if(flag===true){
                return flag
            }
        }
        else if( Array.isArray(trait_group.traits[i]?.currentValue) && trait_group.traits[i]?.currentValue?.length>0 ){
            for(let j in trait_group.traits[i]?.currentValue){
                let value = trait_group.traits[i]?.currentValue[j]
                if(typeof value==='string'&&value!==''){
                    flag=true
                    if(flag===true){
                        return flag
                    }
                }
                if(Array.isArray)
                if(trait_group.traits[i]?.currentValue[j]?.length){
                    flag = true
                    if(flag===true){
                        return flag
                    }
                }
            }
        }
    }
    return flag
}

const check_array = (current_value) => {
    let flag = false
    for(let j in current_value){
        let value = current_value[j]
        if(typeof value==='string'&&value!==''){
            return true
        }
        if(typeof value==='boolean'||typeof value==='number'){
            return true
        }
        if(Array.isArray(value) && value.length>0){
            flag = check_array(value)
            if(flag===true){
                return flag
            }
        }
        if(typeof value==='object'){
            flag = check_object_fill(value)
            if(flag===true){
                return flag
            }
        }
    }
    return flag
}

const check_object_fill = (obj) => {
    let flag = false
    for(let k in obj){
        if(typeof obj[k] === 'string' && obj[k]!==""){
            return true
        }
        if(typeof obj[k]==='boolean'||typeof obj[k]==='number'){
            return true
        }
        if(typeof obj[k] === 'object'){
            flag = check_object_fill(obj[k])
            if(flag===true){
                return flag
            }
        }
        if(Array.isArray(obj[k]) && obj[k].length>0){
            flag = check_array(obj[k])
            if(flag===true){
                return flag
            }
        }
    }
    return flag
}

//trait_group[i].hasOwnProperty('currentValue')  && trait_group[i].currentValue !== null && trait_group[i].currentValue !== '' && trait_group[i].currentValue !== [] 